import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-background flex flex-col items-center justify-center space-y-4"
        role="status"
        aria-label="Verifying authentication"
      >
        <Loader2 className="h-10 w-10 animate-spin text-[#00FFB2]" aria-hidden="true" />
        <p className="text-muted-foreground animate-pulse font-medium">Verifying authentication...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
